module.exports = __webpack_public_path__ + "1_0_59/img/mobile.ca3f80d0.png";